<template>
  <page-status class="order-list-viewer" :loading="loading">
    <div class="order-list">
      <div
        class="list-card"
        v-for="(order, index) in list"
        :key="index"
        @click="onClick(order)"
      >
        <div class="card-content">
          <div class="title">订单号：{{ order.poaCode }}</div>
          <div class="description">
            <span class="label">投保人姓名：</span>
            <span class="value">{{ order.phName }}</span>
          </div>
          <div class="description">
            <span class="label">最后缴费日期：</span>
            <span class="value">{{ order.lastPayDate }}</span>
          </div>
          <div class="description">
            <span class="label">缴费金额：</span>
            <span class="value">{{ order.premium }}元</span>
          </div>
        </div>
      </div>
    </div>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import * as services from '@/services';
import * as utils from '@/utils';

export default {
  name: 'OrderList',
  components: {
    PageStatus,
  },

  data() {
    return {
      loading: false,
      list: [],
    };
  },

  created() {
    this.platform = utils.getClientEnv();
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { certType, certNo } = this.$route.query;

      services.getOrderList(certType, certNo).then(res => {
        this.list = res.data;
        this.loading = false;
      });
    },

    onClick(order) {
      const query = {
        orderNo: order.poaCode,
        phName: order.phName,
        platform: this.platform,
      };
      this.$router.push({ name: 'order-detail', query });
    },
  },
};
</script>

<style lang="less">
.order-list-viewer {
  .order-list {
    padding: 16px;

    .list-card {
      margin-bottom: 16px;
      background-color: #ffffff;
      border-right: 4px solid #108ee9;
      border-radius: 4px;
      box-shadow: 0 2px 8px -2px rgba(50, 72, 94, 0.2);

      .card-content {
        position: relative;
        padding: 16px 0 16px 16px;

        .title {
          font-size: 16px;
          font-weight: bold;
          color: #434b65;
          margin-bottom: 16px;
        }

        .description {
          font-size: 12px;

          .label {
            color: #434b65;
          }

          .value {
            color: #808897;
          }
        }

        .description + .description {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
